"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var colors_1 = require("../colors");
var MuiInputLabel = {
  styleOverrides: {
    root: {
      '&.MuiInputLabel-formControl': {
        color: colors_1.colors.Neutros60
      }
    }
  }
};
exports.default = {
  MuiInputLabel: MuiInputLabel
};